// ** React Imports
import { Suspense, lazy } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

// ** Redux Imports
import { store } from './redux/store'
import { Provider } from 'react-redux'

// ** Intl, CASL & ThemeColors Context
import ability from './configs/acl/ability'
import { AbilityContext } from './utility/context/Can'
import { ThemeContext } from './utility/context/ThemeColors'

// ** ThemeConfig
import themeConfig from './configs/themeConfig'

// ** Toast
import { Toaster } from 'react-hot-toast'

// ** Settings
import defaultSettings from './configs/defaultSettings'
import axios from 'axios'

// ** i18n
import './configs/i18n'

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner'

// ** Ripple Button
import './@core/components/ripple-button'

// ** PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css'

// ** React Hot Toast Styles
import '@styles/react/libs/react-hot-toasts/react-hot-toasts.scss'

// ** Core styles
import './@core/assets/fonts/feather/iconfont.css'
import './@core/scss/core.scss'
import './assets/scss/style.scss'

// ** Service Worker
import * as serviceWorker from './serviceWorker'

import ErrorBoundary from "./ErrorBoundary"

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

const container = document.getElementById('root')
const root = createRoot(container)

// Settings initialization
window.__APP_SETTINGS__ = defaultSettings

async function startApp() {

   if (localStorage.getItem('token')) {
      try {
         const response = await axios.post(
            `https://api.mfauto.com.ua/company/settings?env=${process.env.REACT_APP_NODE_ENV}`,
            { token: localStorage.getItem('token') }
         )

         window.__APP_SETTINGS__ = response.data         
      } catch (error) {
         console.error('Settings load failed, using defaults', error)
         window.__APP_SETTINGS__ = defaultSettings
      }
   }

   root.render(
      <BrowserRouter>
         <Provider store={store}>
            <Suspense fallback={<Spinner />}>
               <AbilityContext.Provider value={ability}>
                  <ThemeContext>
                     <ErrorBoundary>
                        <LazyApp />
                     </ErrorBoundary>
                     <Toaster
                        position={themeConfig.layout.toastPosition}
                        toastOptions={{ className: 'react-hot-toast' }}
                     />
                  </ThemeContext>
               </AbilityContext.Provider>
            </Suspense>
         </Provider>
      </BrowserRouter>
   )
}

startApp()

serviceWorker.unregister()
